import React, { useState } from 'react'
import * as S from './styles'
import {
  FullScreenDialog,
  Input,
  ModalConfirmar,
  TableComponet,
  Titulo,
} from '../../components'
import { Button, CircularProgress, Grid, Stack } from '@mui/material'
import AddCircleOutlineOutlinedIcon from '@mui/icons-material/AddCircleOutlineOutlined'
import SaveIcon from '@mui/icons-material/Save'
import { connect } from 'react-redux'
import { toast } from 'react-toastify'
import { GroupAddOutlined } from '@mui/icons-material'

const timerPadrao = 20 // 20 segundos

function ApresentacaoAdmin(props) {
  const [open, setOpen] = React.useState(false)
  const handleOpen = () => setOpen(true)
  const handleClose = () => setOpen(false)

  const [openModal, setOpenModal] = React.useState(false)
  const handleOpenModal = () => setOpenModal(true)
  const handleCloseModal = () => setOpenModal(false)

  const [loading, setLoading] = useState(false)

  const [relatorios, setRelatorios] = useState([])
  const [apresentacao, setApresentacao] = useState([])
  const [isEditar, setIsEditar] = React.useState(false)
  const [infoRelatorio, setInfoRelatorio] = React.useState({})

  const [timerRelatorio, setTimerRelatorio] = useState(timerPadrao)

  const [labelDialog, setLabelDialog] = React.useState('Selecione um Relatório')
  const [selected, setSelected] = useState([])

  const headers = [
    {
      id: 'nome',
      label: 'Nome',
      props: {
        align: 'left',
      },
    },
    {
      id: 'menu',
      label: 'menu',
      props: {
        align: 'left',
      },
    },
    {
      id: 'subMenu',
      label: 'Submenu',
      props: {
        align: 'left',
      },
    },
  ]

  const headersAp = [
    {
      id: 'nome',
      label: 'Nome',
      props: {
        align: 'left',
      },
    },
    {
      id: 'menu',
      label: 'menu',
      props: {
        align: 'left',
      },
    },
    {
      id: 'subMenu',
      label: 'Submenu',
      props: {
        align: 'left',
      },
    },
    {
      id: 'actionRows',
      label: 'Ações',
      props: {
        align: 'right',
      },
    },
  ]

  let mounted = true
  React.useEffect(() => {
    async function getFiltros() {
      if (mounted) {
        let newRelatorio = JSON.parse(sessionStorage.getItem('empresa'))
        let apresentacaoNew = JSON.parse(localStorage.getItem('apresentacao'))
        let timerRelatorio = JSON.parse(localStorage.getItem('timerRelatorio'))
        setApresentacao(apresentacaoNew || [])
        setTimerRelatorio(timerRelatorio || timerPadrao)
        setRelatorios(newRelatorio.empresa)
      }
    }

    getFiltros()
    return () => (mounted = false)
  }, [])

  function closeDialog() {
    setLabelDialog('Cadastrar Novo Relatórios')
    setIsEditar(false)
    setInfoRelatorio({})
    handleClose()
    //  getRelatorios()
  }

  function inativarRelatorio(data) {
    //setLoading(true)

    // Remove o item da lista
    const novaLista = apresentacao.filter(
      (item) => item.powerBiReportId !== data.powerBiReportId,
    )

    // Atualiza o estado local
    setApresentacao(novaLista)

    // Atualiza o sessionStorage
    localStorage.setItem('apresentacao', JSON.stringify(novaLista))

    handleCloseModal()
  }

  // selecao

  function sincronizarSelecionados() {
    // setLoading(true)

    setApresentacao([...selected])
    closeDialog()
    setSelected([])

    localStorage.setItem('apresentacao', JSON.stringify([...selected]))

    // sincronizar
  }

  function ButtonAction() {
    return (
      <Stack direction="row" xs={12} spacing={2} justifyContent="end">
        <Button
          className="confirm-button"
          variant="contained"
          size="small"
          sx={{ height: '48px', minWidth: '300px', textTransform: 'none' }}
          disabled={loading}
          endIcon={
            loading ? (
              <CircularProgress color="inherit" size={25} />
            ) : (
              <GroupAddOutlined />
            )
          }
          onClick={sincronizarSelecionados}
        >
          Adicionar Relatórios Selecionados
        </Button>
      </Stack>
    )
  }

  const handleSelectAllClick = (event) => {
    if (event.target.checked) {
      const newSelected = relatorios.map((n) => {
        n.idUsuarioAtualizacao = props.user.idUsuario
        return n
      })
      setSelected(newSelected)
      return
    }
    setSelected([])
  }

  const handleClickSelected = (event, relatorio) => {
    const selectedIndex = selected.findIndex(
      (selectedRelatorio) =>
        selectedRelatorio.powerBiReportId === relatorio.powerBiReportId,
    )
    let newSelected = []

    if (selectedIndex === -1) {
      relatorio.idUsuarioAtualizacao = props.user.idUsuario
      newSelected = [...selected, relatorio]
    } else {
      newSelected = selected.filter(
        (selectedRelatorio) =>
          selectedRelatorio.powerBiReportId !== relatorio.powerBiReportId,
      )
    }
    setSelected(newSelected)
  }

  return (
    <S.Container>
      <ModalConfirmar
        open={openModal}
        handleConfirm={() => inativarRelatorio(infoRelatorio)}
        handleClose={handleCloseModal}
        customStyle={{ width: 400 }}
      >
        <S.TitleModal>Deseja remover da Apresentação?</S.TitleModal>
      </ModalConfirmar>

      <Titulo>
        <div>Apresentação - Relatórios Cadastrados</div>
        <Stack
          direction="row"
          spacing={2}
          justifyContent="end"
          marginTop="-26px"
        >
          <Button
            className="confirm-button"
            variant="contained"
            size="medium"
            endIcon={<AddCircleOutlineOutlinedIcon />}
            //sx={{ height: '43px' }}
            onClick={handleOpen}
          >
            Adicionar Relatório
          </Button>
        </Stack>
      </Titulo>
      <S.ContainerForm>
        <Grid container padding={1} spacing={2} marginBottom={1}>
          <Grid xs={3} item>
            <Input
              label="Intervalo do Relatórios (segundos)"
              id={'timerRelatorio'}
              type="number"
              // error={validacao(search)}
              // helperText={
              //   validacao(search) ? 'Essa informação é obrigatória' : ''
              // }
              value={parseInt(timerRelatorio)}
              onChange={(e) => {
                setTimerRelatorio(e.target.value)
              }}
              placeholder="Numero em segundos"
              size="small"
            />
          </Grid>

          <Grid xs={2} item display={'flex'}>
            <Button
              className="confirm-button"
              variant="contained"
              size="large"
              startIcon={
                loading ? (
                  <CircularProgress color="inherit" size={25} />
                ) : (
                  <SaveIcon />
                )
              }
              disabled={loading}
              sx={{ height: '39px' }}
              onClick={() => {
                localStorage.setItem(
                  'timerRelatorio',
                  JSON.stringify(timerRelatorio),
                )
                toast.success('Intervalo Salvo com sucesso', {
                  theme: 'colored',
                })
              }}
            >
              Salvar
            </Button>
          </Grid>
        </Grid>
        <Grid container padding={1}>
          <Grid xs={12}>
            <TableComponet
              headers={headersAp}
              data={apresentacao}
              handlerDeletarAction={(data) => {
                setInfoRelatorio(data)
                handleOpenModal()
              }}
              labelCaption="Nenhum Reltatório Adicionado"
              labelTable="Lista de Relatórios"
              status="ativo"
              statusLabelTrue="Ativo"
              statusLabelFalse="Inativo"
              loading={loading}
            />
          </Grid>
        </Grid>
      </S.ContainerForm>

      <FullScreenDialog
        label={labelDialog}
        open={open}
        handleClose={closeDialog}
      >
        <S.ContainerForm>
          <Grid container padding={1}>
            <Grid xs={12}>
              <TableComponet
                headers={headers}
                data={relatorios}
                labelCaption="Nenhum Reltatório Encontrado"
                labelTable="Lista de Relatórios"
                status="ativo"
                statusLabelTrue="Ativo"
                statusLabelFalse="Inativo"
                loading={loading}
                //selecao
                selected={selected}
                selectedName="powerBiReportId"
                handleClickSelected={handleClickSelected}
                handleSelectAllClick={handleSelectAllClick}
                ActionSelect={ButtonAction}
              />
            </Grid>
          </Grid>
        </S.ContainerForm>
      </FullScreenDialog>
    </S.Container>
  )
}

const mapStateToProps = (store) => ({
  user: store.loginState.user.usuario,
})

export default connect(mapStateToProps)(ApresentacaoAdmin)
